<template>
  <div v-if="visible" class="drawer-right flex-column">
    <div class="col-0 mb5">
      <span class="mr10">
        <el-button type="danger" icon="el-icon-close" size="mini" plain @click="visible = false">关闭窗口</el-button>
      </span>
      <!-- <span v-if="drawerType === 'recommend'" class="mr10">
        <el-button type="primary" size="mini" plain @click="resetMatch">重置匹配</el-button>
        <el-button type="primary" size="mini" plain @click="resetMatchList">系统部门匹配</el-button>
        <el-button type="primary" size="mini" plain @click="resetMatchFormerList">list匹配</el-button>
        <el-button type="primary" size="mini" plain @click="resetMatchLabel">标签匹配</el-button>
        <el-button type="primary" size="mini" plain @click="resetMatchMixed">混合匹配</el-button>
      </span>-->
      <span v-if="drawerType === 'project' || drawerType === 'radish'  || drawerType === 'xueku'" class="mr10">
        <el-button size="mini" type="primary" plain :disabled="joinProjectPending" @click="joinProject"
          >加入项目</el-button
        >
      </span>
      <span v-if="drawerType === 'radish'  || drawerType === 'xueku'" class="mb5 pd-10">灰色背景色标记的人选已存在项目中</span>
    </div>
    <div v-if="drawerType === 'finalRadish'" class="col-0 flex-row pd10">
      <p class="col-0">失败分析：</p>
      <el-input v-model="failReason" autosize type="textarea" placeholder="失败原因分析" />
    </div>
    <div v-if="drawerType === 'finalRadish'" class="pd-10">
      <p class="mb5 ft-danger">请在列表中勾选最终到岗人选，并点击确认</p>
      <div class="flex-row item-center">
        <p>人选来源：</p>
        <el-select v-model="select" class="mr10" size="mini" placeholder="选择人选来源">
          <el-option value="HR" label="HR" />
          <el-option value="猎头" label="猎头" />
          <el-option value="内推" label="内推" />
          <el-option value="其他" label="其他" />
        </el-select>
        <el-button size="mini" type="primary" plain :disabled="addFinalRadishLoading" @click="addFinalRadish"
          >确认</el-button
        >
      </div>
    </div>
    <ProjectTable
      v-if="drawerType === 'project'"
      ref="drawerTable"
      :on-select="onSelectProject"
      :default-query="projectsQuery"
      :on-confirm="onConfirm"
      show-selection
      show-search
      simple
      class-name="col-1 scroll flex-column"
    />
    <radishListMatch
      v-else-if="drawerType === 'recommend'"
      ref="radishList"
      :ids="rids"
      :pid="projectId"
      :onkey-match-mode="onkeyMatchMode"
      :on-confirm="onConfirm"
      class="col-1"
    />
    <radishList
      v-else-if="drawerType === 'radish' || drawerType === 'xueku'"
      ref="radishList"
      :show-search="true"
      :search-obj="searchObj"
      :ids="rids"
      :pid="projectId"
      :type="drawerType"
      :onkey-match-mode="onkeyMatchMode"
      :on-confirm="onConfirm"
      class="col-1"
    />
    <radishList
      v-else
      ref="radishList"
      style="overflow: auto;"
      :show-search="true"
      :search-obj="searchObj"
      :ids="rids"
      :pid="['recommend',  'finalRadish'].includes(drawerType) ? projectId : ''"
      :type="drawerType"
      :on-confirm="onConfirm"
      class="col-1"
    />
  </div>
</template>

<script>
import ProjectTable from './ProjectTable.vue'
import {
  radishScore,
  getRankRange,
  getPerformance,
  getPlatform,
  recommendMatch,
  resetRecommendation,
} from '../constant/utils.js'
// 组件已弃用

const rankRange = {
  '1': ['1', '2'],
  '2': ['1', '2', '3'],
  '3': ['2', '3', '4'],
  '4': ['3', '4', '5'],
  '5': ['4', '5'],
}

export default {
  components: { ProjectTable },
  data() {
    return {
      drawerType: '',
      projectsSelection: [],
      visible: false,
      projectId: '',
      projectsQuery: {},
      searchObj: {},
      select: '',
      payload: undefined,
      failReason: '',
      joinProjectPending: false,
      addFinalRadishLoading: false,
      onConfirm: null,
      onkeyMatchMode: '',
    }
  },
  computed: {
    rids() {
      return this.payload || []
    },
  },
  watch: {
    visible(val) {
      if (!val) return
      if (this.drawerType === 'finalRadish') {
        this.$nextTick(() => {
          this.$nextTick(() => {
            try {
              this.$refs.radishList.$el.childNodes[2].childNodes[0].childNodes[0].style.display = 'none'
            } catch (e) {
              console.error(e)
            }
          })
        })
      }
    },
  },
  methods: {
    closeDrawer(){
      this.visible = false
    },
    // TODO:
    openDrawer(type, project, payload, onkeyMatchMode, callback, onConfirm) {
      const visible = this.visible
      this.onConfirm = onConfirm
      if (visible) {
        this.visible = false
        return this.$nextTick(() => {
          this.openDrawer(type, project, payload, onkeyMatchMode, callback, onConfirm)
        })
      }
      this.payload = payload
      this.ids = payload
      this.projectId = (project && project._id) || ''
      this.drawerType = type
      if (type === 'project' && project) {
        if (!visible) {
          this.projectsQuery = Object.assign(
            {},
            { _id: { $ne: project._id }, 职能模块: project['职能模块'], noPermLimit: true },
          )
        } else {
          this.$refs.drawerTable &&
            this.$refs.drawerTable.setQuery({
              _id: { $ne: project._id },
              职能模块: project['职能模块'],
              noPermLimit: true,
            })
        }
      }
      if (type === 'radish' || type === "xueku") {
        if (!payload) {
          this.$nextTick(() => {
            this.$nextTick(() => {
              if (!this.$refs.radishList) return
              const searchData = {}
              const required = ['职能模块', '平台', '业绩', '职级', '细分职能', '擅长方向', '目标行业', '地域']
              required.map(key => {
                let value = project[key]
                if (value && value.length > 0) {
                  if (key === '目标行业') {
                    key = '行业'
                  }
                  if (key === '职能模块') {
                    value = [value]
                  }
                  searchData[key] = value
                }
              })
              searchData.progress = '空'
              if(type === "xueku"&&project.当前血库公司){
                searchData.公司 = project.当前血库公司
              }
              try {
                this.$refs.radishList.searchData = Object.assign({}, searchData)
                // 项目匹配人选时，查找不使用es
                this.$refs.radishList.searchEsEnable = false
                this.$refs.radishList.listEsEnabled = false
                this.$refs.radishList.handleSearch()
              } catch (error) {
                console.error(error)
              }
            })
          })
        } else {
          this.$nextTick(() => {
            this.$nextTick(() => {
              if (!this.$refs.radishList) return
              const fields = ['职能模块', '平台', '业绩', '职级', '地域', '细分职能']
              if (onkeyMatchMode !== '3') {
                fields.push('目标行业')
              }
              const searchData = {}
              if (onkeyMatchMode === '1') searchData['长期意向'] = ['Y']
              if (onkeyMatchMode === '3') project['职级'] = getRankRange(project['职级'])
              if (['2', '3'].includes(onkeyMatchMode)) {
                project['业绩'] = getPerformance(project['业绩'])
                project['平台'] = getPlatform(project['平台'])
              }
              fields.map(fieldname => {
                const value = project[fieldname]
                if (!value || value.length === 0) return
                if (fieldname === '职能模块') {
                  searchData[fieldname] = [value]
                } else if (fieldname === '目标行业') {
                  searchData['行业'] = value
                } else {
                  searchData[fieldname] = value
                }
              })
              searchData.progress = '空'
              if(type === "xueku"&&project.当前血库公司){
                searchData.公司 = project.当前血库公司
              }
              // 项目匹配人选时，查找不使用es
              this.$refs.radishList.listEsEnabled = false
              this.$refs.radishList.searchEsEnable = false
              this.$refs.radishList.searchData = Object.assign({}, searchData)
              // 项目匹配人选时，查找不使用es
              this.$refs.radishList.searchEsEnable = false
              this.$refs.radishList.listEsEnabled = false
              this.$refs.radishList.$on('onLoaded', radishes => {
                callback && callback(radishes)
              })
            })
          })
        }
      } else if (type === 'targetCompany') {
        this.$nextTick(() => {
          this.$nextTick(() => {
            try {
              window.app.root.$refs.addRadishDrawer.$refs.radishList.showTargetCompany()
            } catch (error) {
              console.error(error)
            }
          })
        })
      } else if (type === 'finalRadish') {
        this.failReason = project.failReason || ''
      }
      if (!visible) this.visible = true
    },
    async joinProject() {
      if (this.joinProjectPending) return
      this.joinProjectPending = true
      const { drawerType, projectsSelection, projectId, payload, onkeyMatchMode } = this
      try {
        if (drawerType === 'project') {
          const ids = projectsSelection.map(val => val._id)
          if (ids.length === 0) return (this.joinProjectPending = false)
          await window.app.service('project').joinProject({ id: projectId, ids })
        }
        if (drawerType === 'radish' || drawerType === 'xueku') {
          const selected = this.$refs.radishList.$refs.radishTable.getChecked() || []
          if (selected.length === 0) return (this.joinProjectPending = false)
          const data = selected.map(radish => {
            const rid = radish._id
            return {
              pid: projectId,
              rid,
              匹配度: radishScore(radish),
              keyMatchMode: onkeyMatchMode,
            }
          })
          await window.app.service('radish').intoProject(data)
        }
        this.$message({
          type: 'success',
          message: '操作成功',
        })
        this.onConfirm && this.onConfirm()
        // window.app.root.$refs.main.$refs.projectTable && window.app.root.$refs.main.$refs.projectTable.getProjects()
      } catch (error) {
        this.$message.error(error.message)
      }
      this.joinProjectPending = false
    },
    onSelectProject(val) {
      this.projectsSelection = val
    },
    close() {
      this.visible = false
      this.select = ''
    },
    async addFinalRadish() {
      if (this.addFinalRadishLoading) return
      this.addFinalRadishLoading = true
      try {
        const selected = this.$refs.radishList.$refs.radishTable.getChecked() || []
        const ids = selected.map(v => v._id)
        await window.app.service('project').modify({
          id: this.projectId,
          param: {
            finalRadishIds: ids,
            failReason: this.failReason,
            finalRadishFrom: this.select,
          },
        })
        this.$message({
          type: 'success',
          message: '操作成功',
        })
        this.close()
        window.app.root.$refs.main.getProject && window.app.root.$refs.main.getProject()
        window.app.root.$refs.main.getProjects && window.app.root.$refs.main.getProjects()
      } catch (error) {
        this.$message.error(error.message)
      }
      this.addFinalRadishLoading = false
    },
    async resetMatch() {
      try {
        await resetRecommendation({ pid: this.projectId })
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async resetMatchList() {
      try {
        await resetRecommendation({ pid: this.projectId, port: '18889' })
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async resetMatchFormerList() {
      try {
        await resetRecommendation({ pid: this.projectId, port: '18890' })
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async resetMatchLabel() {
      try {
        await resetRecommendation({ pid: this.projectId, port: '18891' })
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async resetMatchMixed() {
      try {
        await resetRecommendation({ pid: this.projectId, port: '18892' })
      } catch (e) {
        this.$message.error(e.message)
      }
    },
  },
}
</script>

<style scoped>
.drawer-right {
  max-width: 67vw;
  height: 100%;
  padding: 61px 0 0 0;
  border: 1px solid #eaeefb;
  background-color: #fff;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
  z-index: 1000;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  /* left: 0; */
  border-radius: 0;

  transition: all 0.2s ease-out;
  overflow: hidden;
}

.drawer-right .radish-list {
  flex: auto;
}

.drawer-close {
  display: block;
}
</style>
